var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1105,
    height: 1100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2401 -641)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2408 1191.5C2408 890.229 2652.23 646 2953.5 646 3254.77 646 3499 890.229 3499 1191.5 3499 1492.77 3254.77 1737 2953.5 1737 2652.23 1737 2408 1492.77 2408 1191.5Z",
    stroke: "#173D6E",
    strokeWidth: 8.02083,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#85E4CC",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M206.208 309.313 500.792 309.313 500.792 324.042 206.208 324.042Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.208 250.396 346.135 250.396 346.135 265.125 206.208 265.125Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.208 368.229 500.792 368.229 500.792 382.958 206.208 382.958Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.208 427.146 500.792 427.146 500.792 441.875 206.208 441.875Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.208 486.063 500.792 486.063 500.792 500.792 206.208 500.792Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.208 544.979 500.792 544.979 500.792 559.708 206.208 559.708Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.563 58.9167 132.563 648.083 574.438 648.083 574.438 217.889 415.466 58.9167ZM419.906 84.1846 549.17 213.448C549.198 213.476 549.198 213.524 549.169 213.552 549.155 213.565 549.137 213.573 549.118 213.573L419.781 213.573 419.781 84.2361C419.782 84.1956 419.815 84.1632 419.856 84.1632 419.875 84.1639 419.893 84.1713 419.906 84.1846ZM147.292 633.354 147.292 73.6458 405.052 73.6458 405.052 228.302 559.708 228.302 559.708 633.354Z",
    fill: "#173D6E",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00141 0 0 1 2599 838)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIcon);
export default __webpack_public_path__ + "static/media/paper-icon.4f690c86e68d26cdc186b92e3bacc3c0.svg";
export { ForwardRef as ReactComponent };